import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import PropTypes from 'prop-types';

import Header from 'Layout/Components/Header';
import SideBar from 'Layout/Components/SideBar';
import Footer from 'Layout/Components/Footer';
import EnvironmentBanner from 'Layout/Components/EnvironmentBanner';
import LoadingSpinner from 'Components/LoadingSpinner';
import { getEnvironmentVariables } from 'Store/Actions/Environment/EnvironmentAction';

import 'Layout/Layout.css';
import 'Layout/Layout-dark-mode.css';

const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isLoading = useSelector((state) => state.loader.isLoading);
  const environment = useSelector((state) => state.environment?.environment);
  const isNonProd = environment && environment !== 'prod';

  const [isSidebarOpen, setSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('sidebarOpen');
    return saved !== null ? JSON.parse(saved) : true;
  });

  // Check if current route is a pendingbtt ticket profile
  const isPendingBttTicket = location.pathname.match(/^\/pendingbtt\/[^/]+$/);
  const shouldHideSidebar = !!isPendingBttTicket;

  useEffect(() => {
    dispatch(getEnvironmentVariables());
  }, [dispatch]);

  useEffect(() => {
    localStorage.setItem('sidebarOpen', JSON.stringify(isSidebarOpen));
  }, [isSidebarOpen]);

  const toggleSidebar = () => {
    setSidebarOpen((prevState) => !prevState);
  };

  const getLayoutClass = () => {
    const classes = [];
    if (shouldHideSidebar) classes.push('no-sidebar');
    else if (isSidebarOpen) classes.push('sidebar-open');
    if (isNonProd) classes.push('has-env-banner');
    return classes.join(' ');
  };

  return (
    <div className={`layout ${getLayoutClass()}`}>
      {isNonProd && <EnvironmentBanner environment={environment} />}
      {isLoading && (
        <div className="loading-background">
          <LoadingSpinner fullScreen size="3x" />
        </div>
      )}
      {!shouldHideSidebar && <SideBar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />}
      <Header isSidebarOpen={isSidebarOpen} showAppName={shouldHideSidebar} />
      <div className="main-container">
        <div className="content">
          <main>{children}</main>
        </div>
      </div>
      <Toaster position="bottom-right" toastOptions={{ duration: 4000 }} />
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
